import React from "react";
import { Outlet } from "react-router-dom";

import Sidebar from "./Sidebar";
import Header from "./Header";

// layout component represent the main layout for app
const Layout: React.FC = () => {
  return (
    <>
      <div className="grid grid-cols-9">
        {/* split screen into 9 column 2 for sidebar and for 7 for main content and 3 column for sidebar and 6 column for main content start form meduim screen  */}
        <Sidebar col="col-span-2 md:col-span-3" />
        <main className="col-span-7 md:col-span-6">
          <Header />
          <Outlet />
        </main>
      </div>
    </>
  );
};

export default Layout;
